import { getLocale } from "../runtime";

const sv_enlanguage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `English`
};

const enlanguage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_enlanguage(inputs)
	return "enLanguage";
};

export { enlanguage as "enLanguage" };